module.exports = __webpack_public_path__ + "static/media/switch_camera.4c59ed38.svg";